import { CustomAttributeForm } from '@/hooks'
import { SourceItem } from '.'

export interface ReadMappingData {
	code?: string
	columns?: ReadMappingColumn[]
	columnsLastId?: number
	criteria?: string
	criteriaDescription?: string
	description?: string
	comment?: string
	distinct?: boolean
	name?: string
	outWhere?: string
	outWhereDescription?: string
	postMappingScript?: string
	postMappingScriptDescription?: string
	preMappingScript?: string
	preMappingScriptDescription?: string
	sourceHints?: string
	sourceHintsDescription?: string
	sources?: string
	sourcesDescription?: string
	status?: ReadMappingDataEnums.ReadMappingStatusEnum
	stereotypeId?: number
	targetHints?: string
	targetHintsDescription?: string
	truncate?: boolean
	responsiblePersonId?: number
	responsiblePersonName?: string
	responsibleAnalystId?: number
	responsibleAnalystName?: string
	ownerId?: number
	ownerName?: string
	condition?: string
	rowsetCode?: string
	orderPriority?: number
	sourceItems?: SourceItem[]
	sourceItemsLastId?: number
	customAttributes?: CustomAttributeForm[]
}

export interface ReadMappingColumn {
	id: number
	order: number
	uuid: string
	columnCode: string
	columnSourceStructureId?: number
	columnSourceStructureCode?: string
	columnSourceColumnUuid?: string
	columnSourceType?: ReadMappingColumn.ReadMappingColumnSourceType
	keyFlag?: boolean
	mapping: string
	mappingDescription?: string
	mappingComment?: string
	updateFlag?: boolean
	groupByFlag?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace ReadMappingDataEnums {
	export enum ReadMappingStatusEnum {
		LOGICAL_IN_PROGRESS = 'logical_in_progress',
		LOGICAL_COMPLETED = 'logical_completed',
		PHYSICAL_IN_PROGRESS = 'physical_in_progress',
		PHYSICAL_COMPLETED = 'physical_completed',
		FROZEN = 'frozen',
	}
}

export namespace ReadMappingColumn {
	export enum ReadMappingColumnSourceType {
		API_NODE = 'API_NODE',
		ROW_SET = 'ROW_SET',
	}
}
